<template>
    <div class="layout">
        <Form :model="form" :label-width="100">
            <Row>
                <Col :span="8">
                    <FormItem :label="$t('gscInvoice.t1')">
                        <Input type="text" size="small" readonly v-model="form.ouName"></Input>
                    </FormItem>
                </Col>
                <Col :span="8">
                    <FormItem :label="$t('gscInvoice.t17')">
                        <Input size="small" type="text" readonly v-model="form.currencyCode"></Input>
                    </FormItem>
                </Col>
                <Col :span="8">
                    <FormItem :label="$t('gscInvoice.t32')">
                        <Input size="small" type="text" readonly v-model="form.endDate"></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div class="not-negotiable-tips">
            <h2>{{ $t('gscInvoice.t121') }}</h2>
            <p>{{ $t('gscInvoice.t120') }}</p>
        </div>

        <div class="not-negtiable-tool">
            <Button type="primary" :loading="loading" @click="exportExcel">{{ $t('common.export') }}</Button>
        </div>
        <Table size="small" border :columns="comluns" :data="tableData" :loading="loading"></Table>
        <m-pagination :showElevator="settings.showElevator"
                      :showSizer="settings.showSizer"
                      :currentPage="settings.currentPage"
                      :pageSize="settings.pageSize"
                      :total="settings.total"
                      :pageSizeOpts="settings.pageSizeOpts"
                      @on-page-size-change="onPageSizeChange"
                      @on-current-page-change="onPageChange">
        </m-pagination>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import MPagination from '@/components/awesome/page/pagination/main';
import { exportExcel2 } from './financialAccounting';

export default {
    name: 'notNegotiableDetail',
    components: {
        MPagination,
    },
    data() {
        return {
            form: {
                ouName: '',
                currencyCode: '',
                endDate: '',
            },
            comluns: [
                {
                    title: this.$t('gscInvoice.t123'), // 取价来源
                    key: 'priceSource',
                    align: 'center',
                    width: 120,
                },
                {
                    title: this.$t('gscInvoice.t43'), // 事务类型
                    key: 'transactionType',
                    align: 'center',
                    width: 90,
                },
                {
                    title: this.$t('gscInvoice.t44'), // 事务日期
                    key: 'transactionDate',
                    align: 'center',
                    width: 110,
                    render: (h, params) => {
                        const { transactionDate } = params.row;
                        return h('span', transactionDate ? moment(transactionDate).format('YYYY-MM-DD') : '');
                    },
                },
                {
                    title: this.$t('gscInvoice.t45'), // 接收单号
                    key: 'receiptNum',
                    align: 'center',
                    width: 110,
                },
                {
                    title: this.$t('gscInvoice.t46'), // 订单号
                    key: 'poNum',
                    align: 'center',
                    width: 150,
                },
                {
                    title: this.$t('gscInvoice.t122'), // 订单日期
                    key: 'creationDate',
                    align: 'center',
                    width: 150,
                    render: (h, params) => {
                        const { creationDate } = params.row;
                        return h('span', creationDate ? moment(creationDate).format('YYYY-MM-DD HH:mm:ss') : '');
                    },
                },
                // {
                //     title: this.$t('gscInvoice.t47'), // 接收行号
                //     key: 'lineNum',
                //     align: 'center',
                //     width: 90,
                // },
                {
                    title: this.$t('gscInvoice.t48'), // 接收日期
                    key: 'rcvDate',
                    align: 'center',
                    width: 110,
                    render: (h, params) => {
                        const { rcvDate } = params.row;
                        return h('span', rcvDate ? moment(rcvDate).format('YYYY-MM-DD') : '');
                    },
                },
                // {
                //     title: '送货单号',
                //     key: 'deliveryNumber',
                //     align: 'center',
                //     width: 90,
                // },
                {
                    title: this.$t('gscInvoice.t50'), // 物料编码
                    key: 'itemCode',
                    align: 'center',
                    width: 140,
                },
                {
                    title: this.$t('gscInvoice.t51'), // 物料描述
                    key: 'itemName',
                    align: 'center',
                    width: 300,
                    render: (h, params) => {
                        return h('Tooltip', {
                            props: {
                                content: params.row.itemName,
                                placement: 'top',
                            },
                            class: 'm-tooltip-overflow',
                        }, params.row.itemName);
                    },
                },
                {
                    title: this.$t('gscInvoice.t52'), // 单位
                    key: 'itemUom',
                    align: 'center',
                    width: 80,
                },
                {
                    title: this.$t('gscInvoice.t54'), // 数量
                    key: 'quantity',
                    align: 'center',
                    width: 90,
                },
                {
                    title: this.$t('gscInvoice.t56'), // 币种
                    key: 'currencyCode',
                    align: 'center',
                    width: 90,
                },
            ],
            tableData: [],
            loading: false,
            settings: {
                currentPage: 1,
                pageSize: 10,
                total: 200,
                needValidation: true,
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
            },
        };
    },
    methods: {
        init() {
            const { ouName, currencyCode, endDate, vendorId, orgId, vendorSiteCode } = this.$route.query;
            this.form = {
                ouName,
                currencyCode,
                endDate,
                orgId,
                vendorId,
                vendorSiteCode,
            };
            this.onSubmit();
        },
        onSubmit() {
            this.loading = true;
            const { currentPage, pageSize } = this.settings;
            axios.post('/gscint/hw/ispInvoice/nonInvoicedList', {
                ...this.form,
                vendorCode: this.vendorCode,
                pageNum: currentPage,
                pageSize,
                language: this.switchLanguage(this.$i18n.locale),
            })
                .then((res) => {
                    this.loading = false;
                    const { list, total } = res.data.data;
                    if (list) {
                        this.tableData = list;
                        this.settings.total = total;
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                });
        },
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.onSubmit();
        },
        /** 页容量改变时触发 */
        onPageSizeChange(pageSize) {
            this.settings.pageSize = pageSize;
            this.onSubmit();
        },
        exportExcel() {
            this.loading = true;
            exportExcel2('/gscint/hw/ispInvoice/exportNonInvoicedList', {
                ...this.form,
                vendorCode: this.vendorCode,
                language: this.switchLanguage(this.$i18n.locale),
            }, `${this.$t('gscInvoice.t117')} ${moment().format('YYYY-MM-DD')}.xls`, this)
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    activated() {
        this.init();
    },
    mounted() {
        this.init();
    },
};
</script>
<style scoped lang="less">
.layout {
    height: 100%;
    padding: 20px;
    background: #FFF !important;
}
.not-negotiable-tips {
    padding: 20px 0 20px 100px;
    color: red;
    line-height: 20px;
    h2 {
        font-size: 13px;
        font-weight: bold;
    }
}
.not-negtiable-tool {
    margin-bottom: 10px;
    .tips {
        margin-left: 10px;
        color: red;
        font-size: 13px;
    }
}
</style>
